<div *ngIf="slides?.length > 0" class="main-wrapper">
  <div class="glide-wrapper" [ngClass]="{'alignment': slides?.length < 6}">
    <ngx-glide [showArrows]="(slides?.length > 6||isMobile) ? true : false" [showBullets]="false" [type]="'slider'" [bound]="true" [gap]="20"
              [arrowLeftLabel]="''" [arrowRightLabel]="''"
              [perView]="isMobile ? 1.2 : slides?.length > 5 ? 5.2 : slides?.length">
      <a *ngFor="let item of slides; let i = index;" class="card lightgallerydocs" [href]="item?.cdn_path">
        <img loading="lazy" class="img" [attr.data-src]="item?.cdn_path" defaultImg="blur" [alt]="'medical doc '+i" />
      </a>
    </ngx-glide>
  </div>
</div>